/* eslint-disable arrow-body-style */
import { useMemo } from "react";
import { notification } from "tea-component";
import { useIntl } from "umi";

const errorCodeList = [1001, 1002, 1004];

/**
 * 自定义Hook：错误提示处理
 * 
 * 根据错误码显示对应的错误提示通知
 * 
 * @returns {function} showErrorTips - 显示错误提示的函数
 * @param {number} code - 错误码
 * @param {string} [throwError] - 可选，当错误码不在预设列表中时抛出此错误
 * 
 * @example
 * const showErrorTips = useErrorTips();
 * showErrorTips(1001); // 显示"dba_invalid_params"对应的错误提示
 */
export const useErrorTips = () => {
  const { formatMessage, locale } = useIntl();

  const errorTipsMap = useMemo(() => {
    return {
      1001: formatMessage({ id: "dba_invalid_params" }),
      1002: formatMessage({ id: "dba_internal_error" }),
      1004: formatMessage({ id: "dba_internal_length_max" }),
      1005: formatMessage({ id: "dba_ds_report_export_error" }),
      // 可继续扩展更多错误码...
    };
  }, [locale]);

  const showErrorTips = (code: number, throwError?:string) => {
    if(code === 0) return;
    if (errorCodeList?.includes(code)) {
      notification.error({
        description: errorTipsMap?.[code] || formatMessage({ id: "errorTips.default" }),
        duration: 2000,
      });
    } else {
      if(throwError) {
        return Promise.reject(throwError || '');
      }
    }
  };

  return showErrorTips;
};